import FocusTrap from 'focus-trap-react';
import React, { FC, ReactNode, useEffect } from 'react';

import { WarningGray } from '../../assets';
import SideBySide from '../side-by-side/SideBySide';

import './Modal.scss';

interface Props {
  isOpen: boolean;
  title?: string;
  titleActions?: ReactNode; // Components to place next to the title on the right side
  icon?: string;
  className?: string;
  closeModal?: () => void;
}

const Modal: FC<Props> = ({ isOpen, title, titleActions, children, icon, className = '', closeModal }) => {
  const keydownHandler = ({ key }) => {
    switch (key) {
      case 'Escape':
        closeModal();
        break;
      default:
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', keydownHandler);
    return () => document.removeEventListener('keydown', keydownHandler);
  });

  if (!isOpen) return null;

  const iconRenderer = (icon: string) => {
    switch (icon) {
      case 'WarningGray':
        return <WarningGray />;
      default:
        break;
    }
  };

  return (
    <FocusTrap active={isOpen}>
      <aside className={`modal-background ${className}`} aria-modal='true' role='dialog'>
        <div className='modal'>
          <header className='modal-top'>
            <SideBySide>
              <h2 className='modal-title'>
                {icon ? <span>{iconRenderer(icon)}</span> : null}
                {title}
              </h2>
              <div>{titleActions}</div>
            </SideBySide>
          </header>
          <main className='modal-container'>{children}</main>
        </div>
      </aside>
    </FocusTrap>
  );
};

export default Modal;
